import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InmueblesService {

  inmuebles:any[] = [];

  constructor() { }

  setInmuebles(value){
    this.inmuebles = value;
  }

  getInmuebles(){
    return this.inmuebles;
  }
}
